import { chakra, Grid, GridItem } from '@chakra-ui/react';

export const LectureGrid = chakra(Grid, {
  baseStyle: {
    gridTemplateColumns: '1fr',
    gridGap: '16px',
    '@media (min-width: 48em)': {
      gridTemplateColumns: '1fr minmax(228px, 288px)',
    },
  },
});

export const LectureGridContent = chakra(GridItem, {
  baseStyle: {
    display: 'contents',
    '@media (min-width: 48em)': {
      display: 'grid',
      flexDirection: 'column',
      gridGap: '16px',
    },
  },
});

export const LectureGridSidebar = chakra(GridItem, {
  baseStyle: {
    display: 'contents',
    '@media (min-width: 48em)': {
      display: 'grid',
      flexDirection: 'column',
      gap: '16px',
      gridColumn: '2 / -1',
      gridRow: '1 / 3',
      gridTemplateRows: 'max-content',
    },
  },
});

export const LectureGridSpeakers = chakra(GridItem, {
  baseStyle: {
    order: '1',
    gridColumn: '1 / 2',
  },
});

export const LectureGridTabs = chakra(GridItem, {
  baseStyle: {
    order: '3',
    gridColumn: '1 / 2',
  },
});

export const LectureGridDownloads = chakra(GridItem, {
  baseStyle: {
    order: '2',
  },
});

export const LectureGridSuggestions = chakra(GridItem, {
  baseStyle: {
    order: '4',
  },
});
